var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: { size: "lg", "ok-disabled": _vm.isAdding },
      on: { ok: _vm.submitForm },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("div", { attrs: { slot: "modal-title" }, slot: "modal-title" }, [
        _vm._v(
          "\n    " + _vm._s(_vm.$t("message.menu.company_address")) + "\n  "
        )
      ]),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "mb-3" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-info",
                on: { click: _vm.changePageModal }
              },
              [_vm._v("\n        " + _vm._s(_vm.showTextTitle) + "\n      ")]
            )
          ]),
          _vm._v(" "),
          _vm.formAction === "choose"
            ? [
                _c("table", { staticClass: "table" }, [
                  _c("thead", { staticClass: "thead-light" }, [
                    _c("tr", [
                      _c("th", { attrs: { scope: "col" } }, [
                        _vm._v(_vm._s(_vm.$t("message.company_address.choose")))
                      ]),
                      _vm._v(" "),
                      _c("th", { attrs: { scope: "col" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "message.company_address.company_customer_name"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("th", { attrs: { scope: "col" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("message.company_address.address"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("th", { attrs: { scope: "col" } }, [
                        _vm._v(_vm._s(_vm.$t("message.company_address.action")))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.companies, function(company, index) {
                      return _c("tr", { key: company.id }, [
                        _c("td", [
                          _c("div", { staticClass: "form-check" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedUserCompany,
                                  expression: "selectedUserCompany"
                                }
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "radio",
                                name: "exampleRadios",
                                id: "company" + (index + 1),
                                "data-id-company": company.id,
                                disabled: !company.address_province_id
                              },
                              domProps: {
                                value: company,
                                checked: _vm._q(
                                  _vm.selectedUserCompany,
                                  company
                                )
                              },
                              on: {
                                change: function($event) {
                                  _vm.selectedUserCompany = company
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", {
                              staticClass: "form-check-label",
                              attrs: { for: "company" + (index + 1) }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("div", [_vm._v(_vm._s(company.company))]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v("Tax ID: " + _vm._s(company.tax_id))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-2" }, [
                            _c(
                              "span",
                              {
                                staticClass: "badge badge-pill badge-light",
                                staticStyle: { "background-color": "#E0E0E0" }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      company.is_company
                                        ? _vm.$t(
                                            "message.company_address.juristic_person"
                                          )
                                        : _vm.$t(
                                            "message.company_address.normal_person"
                                          )
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n            " +
                              _vm._s(company.address) +
                              "\n            "
                          ),
                          !company.address_province_id
                            ? _c("div", { staticClass: "text-danger mt-2" }, [
                                _c("i", {
                                  staticClass:
                                    "fas fa-exclamation-triangle -status-alert"
                                }),
                                _vm._v(
                                  "  " +
                                    _vm._s(
                                      _vm.$t(
                                        "message.company_address.incomplete_data"
                                      )
                                    ) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "a",
                            {
                              attrs: { href: "" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.setUserAddressData(index)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("message.button.edit")) +
                                  "\n            "
                              )
                            ]
                          )
                        ])
                      ])
                    }),
                    0
                  )
                ])
              ]
            : _vm.formAction === "add" || _vm.formAction === "edit"
            ? [
                _c("company-address-form", {
                  ref: "companyAddressForm",
                  on: {
                    finished: function($event) {
                      return _vm.finishUpdate()
                    }
                  }
                })
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          attrs: { slot: "modal-cancel" },
          on: {
            click: function($event) {
              _vm.showModal = false
            }
          },
          slot: "modal-cancel"
        },
        [_vm._v(_vm._s(_vm.$t("message.button.close")))]
      ),
      _vm._v(" "),
      _c("div", { attrs: { slot: "modal-ok" }, slot: "modal-ok" }, [
        _vm._v("\n    " + _vm._s(_vm.submitButtonText) + "\n  ")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a2d46ba", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a2d46ba","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/components/CompanyAddressModal.vue
// module id = 1829
// module chunks = 0